module.exports = __webpack_public_path__ + "img/bar-chart-square-03.c39b3a7e.svg";